import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocumentForm } from '../../requests/getDocumentForm';
import { DocumentParams } from '../../types/DocumentParams';

export const useDocumentForm = (
  documentId: string,
  documentParams: DocumentParams,
  formIdentifier: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentForm>>
  >({
    queryKey: [
      DOCUMENTS_BASE_PATH,
      documentId,
      'formv2',
      formIdentifier,
      params,
    ],
    queryFn: () =>
      getDocumentForm(
        constructGet,
        documentId,
        documentParams,
        formIdentifier,
        params,
      ),
    enabled:
      Boolean(documentId) &&
      Boolean(formIdentifier) &&
      (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'documentForm'),
    ...rest,
  };
};
